import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typeahead,
  Menu,
  MenuItem,
  withAsync,
  Highlighter,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "./../../axios";
import Lodash from "lodash";

import defaultProfileIcon from "./../../assets/images/profile-icon.png";

const AsyncTypeahead = withAsync(Typeahead);

const UserSearch = (props) => {
  const { defaultSelected, multiple = false, handleSelection } = props;

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [query, setQuery] = useState("");
  useEffect(() => {
    if (!defaultSelected) return;
    if (!Lodash.isEqual(defaultSelected, selectedUsers)) {
      if (Array.isArray(defaultSelected)) setSelectedUsers(defaultSelected);
      else setSelectedUsers([defaultSelected]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelected]);

  const _innerHandleSelection = (value) => {
    if (handleSelection) handleSelection(value[0]);
    setSelectedUsers(value);
  };

  const onSearch = (query) => {
    setQuery(query);
    setLoading(true);
    Axios.get(`/api/admin/search-users-in-mentorstudent?email=${query}`)
      .then((res) => {
        //destructure data
        const { items } = res.data;
        console.log(items, "user");
        setOptions(items);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  return (
    <AsyncTypeahead
      id="my-typeahead-id"
      isLoading={loading}
      labelKey={(option) => {
        return `${option.firstName || option._source.firstName} ${
          option.lastName || (option._source && option._source.lastName)
        }`;
      }}
      onSearch={onSearch}
      onChange={_innerHandleSelection}
      placeholder={"Search User With Email"}
      searchText="Searching, please wait..."
      // useCache={true}
      selected={selectedUsers}
      options={options}
      multiple={multiple}
      renderMenu={(results, menuProps) => renderMenu(results, menuProps, query)}
      filterBy={() => true}
      // delay={200}
    />
  );
};

const renderMenu = (results, menuProps, query = "") => {
  return (
    <Menu {...menuProps}>
      {results &&
        results.map((result, idx) => {
          const firstName = result.firstName;
          const lastName = result.lastName;
          const email = result.email;
          return (
            <MenuItem key={idx} option={result} position={idx}>
              <img
                alt={defaultProfileIcon}
                src={result.profilePicUrl || defaultProfileIcon}
                style={{
                  height: "50px",
                  marginRight: "10px",
                  width: "50px",
                }}
              />
              <strong key="name">{`${firstName} ${lastName}`}<p>Email: {email}</p></strong>
            </MenuItem>
          );
        })}
    </Menu>
  );
};

export default UserSearch;
